module.exports = __webpack_public_path__ + "static/media/balcony.af8e4d57.svg";